import React from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetType } from '../../types/api/ElementType';
import { PersonalMessagesBlock } from '../../_blocks/PersonalMessages';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { Icons, SVGIcon } from '../../components/atoms/SVG';
import { Namespace } from '../../translation/namespace';

type PersonalMessageWidgets =
  | WidgetType.teamroommessages
  | WidgetType.editorialMessages
  | WidgetType.recommendationmessages;

export type PersonalMessagesWidget = WidgetShape<[PersonalMessagesBlock], PersonalMessageWidgets>;

export function PersonalMessagesWidget({ blocks, elementType, ...headerProps }: PersonalMessagesWidget) {
  const { t } = useTranslation(Namespace.Widget);

  const getIconByWidgetType = (widgetTypes: PersonalMessageWidgets): SVGIcon => {
    switch (widgetTypes) {
      case WidgetType.editorialMessages:
        return Icons.EDIT_PENCIL;
      case WidgetType.recommendationmessages:
        return Icons.RECOMMEND_PAPERPLANE;
      case WidgetType.teamroommessages:
      default:
        return Icons.TEAMROOM_PEOPLE;
    }
  };

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      icon={getIconByWidgetType(elementType)}
      widgetType={elementType}
      hierarchy={3}
      title={t(`header.${elementType}`)}
    >
      <PersonalMessagesBlock {...blocks[0]} />
    </DefaultWidgetWithHeader>
  );
}
